export default {
  dashboard: {
    company: {
      total: "Total number of companies widget",
    },
    person: {
      total: "Total number of contacts widget",
    },
    invoice: {
      action: "Invoice actions",
      yearlyChart: "Yearly report paid invoices",
    },
  },

  company: {
    search: "Search companies",
    list: "Companies list",

    info: "Company name",

    address: "Addresses",
    emailAddress: "Email addresses",
    bankAccount: "Bankaccounts",
    phoneNumber: "Phone numbers",

    contactPerson: "Company contact",
    relationCompany: "Associated companies",
    businessNumbers: "Business numbers",

    dossier: {
      list: "Dossier list",
      search: "Dossier search",
    },
  },

  person: {
    search: "Search contacts",
    list: "Contacts list",

    info: "Contact person name",

    address: "Addresses",
    emailAddress: "Email addresses",
    bankAccount: "Bankaccounts",
    phoneNumber: "Phone numbers",

    contactPerson: "Linked companies",
    personNumbers: "Contact person numbers",

    dossier: {
      list: "Dossier overview",
      search: "Search dossier",
    },
  },

  invoice: {
    list: "Invoice list",
    search: "Search invoice",
    invoice: "Invoice data",
    target: "Invoice for",
    item: "Invoice lines"
  },
}
